import {useEffect} from 'react';
import type {RefObject} from 'react';

interface Dimensions {
  width: number;
  height: number;
}

export function useResizeObserver<T extends HTMLElement>(
  elementRef: RefObject<T>,
  onResize: (dimensions: Dimensions) => void
): void {
  useEffect(() => {
    const element = elementRef.current;

    if (!element || typeof onResize !== 'function') {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) {
        return;
      }
      const {width, height} = entry.contentRect;
      onResize({width, height});
    });

    observer.observe(element);

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, [elementRef, onResize]);
}
